export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_14.7b298172.jpg";